import { render, staticRenderFns } from "./DeleDiff.vue?vue&type=template&id=18ee35d4&scoped=true&"
import script from "./DeleDiff.vue?vue&type=script&lang=js&"
export * from "./DeleDiff.vue?vue&type=script&lang=js&"
import style0 from "./DeleDiff.vue?vue&type=style&index=0&id=18ee35d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ee35d4",
  null
  
)

export default component.exports